module.exports = __webpack_public_path__ + "img/b2e65139-1eef-466c-9b52-18e084f749e3.3d228340.png";